import Form from 'shared/components/Form'
import { IInputProps } from 'shared/components/Input/InputComponent.types'
import { colors } from 'shared/styles/colors'
import dimensions from 'shared/styles/dimensions'
import styled, { css } from 'styled-components'

const { componentHeight } = dimensions

export const StyledForm = styled(Form)`
  padding: 0;
`

export const StyledInput = styled.input<IInputProps>`
  width: 100%;
  height: ${componentHeight.large}px;

  border: 1px solid ${colors.grayLight};
  border-radius: 4px;

  padding: 12px 10px;

  font-weight: 400;
  font-size: 12px;

  margin: 10px 0px;

  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
      background-color: ${colors.white};
    `}
`
